import useSWRImmutable from "swr/immutable";
import { relativeURL } from "../relativeURL";

const fetcher = (url) => fetch(url).then((res) => res.json());

export function useSingleConversion(pathwayInternalId, native, to_type) {
  const { data, error } = useSWRImmutable(
    () =>
      relativeURL(`/api/conversion/${pathwayInternalId}/${native}/${to_type}`),
    fetcher
  );
  return {
    conversionData: data,
    isLoading: !error && !data,
    isError: error,
  };
}
